import { SUPER_ADMIN_SEARCH_COMPLETE } from '../types';

interface SearchStatusState {
  requestId: string | null;
  error: string | null;
}

interface SearchStatusAction {
  type: string;
  requestId?: string | null;
  error?: string | null;
}

const initialState: SearchStatusState = { requestId: null, error: null };

const SearchStatus = (
  state: SearchStatusState = initialState,
  action: SearchStatusAction,
): SearchStatusState => {
  switch (action.type) {
    case SUPER_ADMIN_SEARCH_COMPLETE:
      return { requestId: action.requestId ?? null, error: action.error ?? null };
    default:
      return state;
  }
};

export default SearchStatus;
